/**
 *
 * Auth
 *
 */

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import Public from "containers/public/loadable";
import { Route, Switch } from "react-router-dom";
import injectReducer from "utils/inject-reducer";
import injectSaga from "utils/inject-saga";
import reducer from "./reducer";
import saga from "./saga";
// import AuthorizedRoute from '../app';

import FullPageLoader from "components/full-page-loader";
import Dashboard from "containers/dashboard/loadable";
import * as auth from "./actions";

import "./styles.scss";

class Auth extends React.Component {
  constructor(props) {
    super(props);

    this.handleAuth();
  }

  handleAuth() {
    this.props.checkToken();
  }

  render() {
    return (
      <Switch>
        {this.props.pending ? (
          <FullPageLoader />
        ) : this.props.logged ? (
          <Route path="/" component={Dashboard} />
        ) : (
          <Route path="/" component={Public} />
        )}
      </Switch>
    );
  }
}

Auth.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  pending: store.auth.pending,
  logged: store.auth.logged,
  token: store.auth.token,
  id: store.auth.id,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    // Always attempt token check — the server cookie determines if the session is valid
    checkToken: () => dispatch(auth.checkToken()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: "auth", reducer });
const withSaga = injectSaga({ key: "auth", saga });

export default compose(withReducer, withSaga, withConnect)(Auth);
